var pauseSocial = false;

function toggleSocial(event) {
    event.preventDefault();
    pauseSocial = !pauseSocial;
    if (pauseSocial) {
        $('div#socialPause').addClass('selected');
        $('div#socialPause a').html('<span class="ic-sr-only">Play Social Ticker</span>');  //TODO: LANGC: get french translation and make dynamic
    } else {
        $('div#socialPause').removeClass('selected');
        $('div#socialPause a').html('<span class="ic-sr-only">Pause Social Ticker</span>');
    }
}

$(function () {
    $.fn.rotatingSocial = function (p) {
        var p = p || {};
        var _timerLength = p && (p.timerLength != null) ? p.timerLength : 5000,
            _transitionLength = p && (p.transitionLength != null) ? p.transitionLength : 1000;
        var _container = $(this),
        //.newsItem class is generated in topFive.aspx.cs file
            _news = _container.children('ul').children('li'),
            _index = 0;
        ChangeSocial();

        function ChangeSocial() {
            if (!pauseSocial) {
                _news.hide();
                _news.eq(_index).show();
                _index++;
                if (_index >= _news.length) {
                    _index = 0;
                }
            }
            setTimeout(ChangeSocial, _timerLength);
        }
    };
    $('#socialScrollContainer').rotatingSocial();
});
